module.exports = __webpack_public_path__ + "img/check_circle0.a1b22960.png";